"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6688],{

/***/ 40633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  /* background: ",
        "; */\n  /* border-radius: ",
        "; */\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return null;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c0268686-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-c0268686-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 85448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 53897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.11997 14.7101L12 10.8301L15.88 14.7101C16.27 15.1001 16.9 15.1001 17.29 14.7101C17.68 14.3201 17.68 13.6901 17.29 13.3001L12.7 8.7101C12.31 8.3201 11.68 8.3201 11.29 8.7101L6.69997 13.3001C6.30997 13.6901 6.30997 14.3201 6.69997 14.7101C7.08997 15.0901 7.72997 15.1001 8.11997 14.7101Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 13947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74566);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline dotted;\n  text-decoration-color: ",
        ";\n  text-underline-offset: 0.1em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TooltipText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5b87ff15-0"
})(_templateObject(), function(param) {
    var theme = param.theme, decorationColor = param.decorationColor;
    var ref;
    return "".concat((theme === null || theme === void 0 ? void 0 : theme.colors) && decorationColor ? theme.colors[decorationColor] : theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.textSubtle);
});
/* harmony default export */ __webpack_exports__["Z"] = (TooltipText);


/***/ }),

/***/ 32519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &::after {\n    display: inline-block;\n    animation: ellipsis 1.25s infinite;\n    content: '.';\n    width: 1em;\n    text-align: left;\n  }\n  @keyframes ellipsis {\n    0% {\n      content: '.';\n    }\n    33% {\n      content: '..';\n    }\n    66% {\n      content: '...';\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Dots = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-818b03ea-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Dots);


/***/ }),

/***/ 26688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WP": function() { return /* binding */ MinimalPositionCard; },
/* harmony export */   "uK": function() { return /* binding */ StableFullPositionCard; }
/* harmony export */ });
/* unused harmony export StableFullPositionCardContainer */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1505);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(10759);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(74566);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(13947);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(40633);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(53897);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(39917);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(45388);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(85448);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(186);
/* harmony import */ var components_NextLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12966);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68486);
/* harmony import */ var hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19639);
/* harmony import */ var hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2629);
/* harmony import */ var utils_prices__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(98045);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29315);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56974);
/* harmony import */ var views_RemoveLiquidity_RemoveStableLiquidity_hooks_useStableDerivedBurnInfo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89216);
/* harmony import */ var views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12353);
/* harmony import */ var _state_wallet_hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5460);
/* harmony import */ var _utils_currencyId__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(29159);
/* harmony import */ var _utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73938);
/* harmony import */ var _Card__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95934);
/* harmony import */ var _Layout_Column__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(941);
/* harmony import */ var _Logo_CurrencyLogo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96459);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19259);
/* harmony import */ var _Layout_Row__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30445);
/* harmony import */ var _Loader_Dots__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32519);
/* harmony import */ var _utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59604);
/* harmony import */ var _state_swap_hooks__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(18281);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

























var FixedHeightRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowBetween */ .m0).withConfig({
    componentId: "sc-6124bda1-0"
})(_templateObject());
var useTokensDeposited = function(param) {
    var pair = param.pair, totalPoolTokens = param.totalPoolTokens, userPoolBalance = param.userPoolBalance;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(!!pair && !!totalPoolTokens && !!userPoolBalance && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalPoolTokens.quotient, userPoolBalance.quotient) ? [
        pair.getLiquidityValue(pair.token0, totalPoolTokens, userPoolBalance, false),
        pair.getLiquidityValue(pair.token1, totalPoolTokens, userPoolBalance, false), 
    ] : [
        undefined,
        undefined
    ], 2), token0Deposited = ref[0], token1Deposited = ref[1];
    return [
        token0Deposited,
        token1Deposited
    ];
};
var useTotalUSDValue = function(param) {
    var currency0 = param.currency0, currency1 = param.currency1, token0Deposited = param.token0Deposited, token1Deposited = param.token1Deposited;
    var token0Price = (0,hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(currency0);
    var token1Price = (0,hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(currency1);
    var token0USDValue = token0Deposited && token0Price ? (0,utils_prices__WEBPACK_IMPORTED_MODULE_24__/* .multiplyPriceByAmount */ .a)(token0Price, parseFloat(token0Deposited.toSignificant(6))) : null;
    var token1USDValue = token1Deposited && token1Price ? (0,utils_prices__WEBPACK_IMPORTED_MODULE_24__/* .multiplyPriceByAmount */ .a)(token1Price, parseFloat(token1Deposited.toSignificant(6))) : null;
    return token0USDValue && token1USDValue ? token0USDValue + token1USDValue : null;
};
var usePoolTokenPercentage = function(param) {
    var userPoolBalance = param.userPoolBalance, totalPoolTokens = param.totalPoolTokens;
    return !!userPoolBalance && !!totalPoolTokens && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalPoolTokens.quotient, userPoolBalance.quotient) ? new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .Percent */ .gG(userPoolBalance.quotient, totalPoolTokens.quotient) : undefined;
};
var withLPValuesFactory = function(param) {
    var useLPValuesHook = param.useLPValuesHook, hookArgFn = param.hookArgFn;
    return function(Component) {
        return function(props) {
            var account = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_8__/* .useWeb3React */ .Ge)().account;
            var currency0 = props.showUnwrapped ? props.pair.token0 : (0,_utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_13__/* .unwrappedToken */ .Bv)(props.pair.token0);
            var currency1 = props.showUnwrapped ? props.pair.token1 : (0,_utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_13__/* .unwrappedToken */ .Bv)(props.pair.token1);
            var userPoolBalance = (0,_state_wallet_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useTokenBalance */ .mM)(account !== null && account !== void 0 ? account : undefined, props.pair.liquidityToken);
            var totalPoolTokens = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props.pair.liquidityToken);
            var poolTokenPercentage = usePoolTokenPercentage({
                totalPoolTokens: totalPoolTokens,
                userPoolBalance: userPoolBalance
            });
            var args = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
                return hookArgFn({
                    userPoolBalance: userPoolBalance,
                    pair: props.pair,
                    totalPoolTokens: totalPoolTokens
                });
            }, [
                userPoolBalance,
                props.pair,
                totalPoolTokens
            ]);
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(useLPValuesHook(args), 2), token0Deposited = ref[0], token1Deposited = ref[1];
            var totalUSDValue = useTotalUSDValue({
                currency0: currency0,
                currency1: currency1,
                token0Deposited: token0Deposited,
                token1Deposited: token1Deposited
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({}, props), {
                currency0: currency0,
                currency1: currency1,
                token0Deposited: token0Deposited,
                token1Deposited: token1Deposited,
                totalUSDValue: totalUSDValue,
                userPoolBalance: userPoolBalance,
                poolTokenPercentage: poolTokenPercentage
            }));
        };
    };
};
var withLPValues = withLPValuesFactory({
    useLPValuesHook: useTokensDeposited,
    hookArgFn: function(param) {
        var pair = param.pair, userPoolBalance = param.userPoolBalance, totalPoolTokens = param.totalPoolTokens;
        return {
            pair: pair,
            userPoolBalance: userPoolBalance,
            totalPoolTokens: totalPoolTokens
        };
    }
});
var withStableLPValues = withLPValuesFactory({
    useLPValuesHook: views_RemoveLiquidity_RemoveStableLiquidity_hooks_useStableDerivedBurnInfo__WEBPACK_IMPORTED_MODULE_10__/* .useGetRemovedTokenAmounts */ .N,
    hookArgFn: function(param) {
        var userPoolBalance = param.userPoolBalance;
        var ref;
        return {
            lpAmount: userPoolBalance === null || userPoolBalance === void 0 ? void 0 : (ref = userPoolBalance.quotient) === null || ref === void 0 ? void 0 : ref.toString()
        };
    }
});
function MinimalPositionCardView(param) {
    var pair = param.pair, currency0 = param.currency0, currency1 = param.currency1, token0Deposited = param.token0Deposited, token1Deposited = param.token1Deposited, totalUSDValue = param.totalUSDValue, userPoolBalance = param.userPoolBalance, poolTokenPercentage = param.poolTokenPercentage;
    var isStableLP = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* .StableConfigContext */ .UA);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var poolData = (0,_state_swap_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useLPApr */ .aT)(pair);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: userPoolBalance && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThan */ .QA.greaterThan(userPoolBalance.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_9__/* .BIG_INT_ZERO */ .iV) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Card__WEBPACK_IMPORTED_MODULE_14__/* .CsLightCard */ .TJ, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_15__/* .AutoColumn */ .Tz, {
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FixedHeightRow, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                color: "text",
                                bold: true,
                                children: t("LP tokens in your wallet")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_17__/* .DoubleCurrencyLogo */ .ge, {
                                        currency0: currency0,
                                        currency1: currency1,
                                        margin: true,
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        small: true,
                                        color: "textSubtle",
                                        children: [
                                            currency0.symbol,
                                            "-",
                                            currency1.symbol,
                                            " LP"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                    flexDirection: "column",
                                    alignItems: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                            children: userPoolBalance ? userPoolBalance.toSignificant(4) : "-"
                                        }),
                                        Number.isFinite(totalUSDValue) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                            small: true,
                                            color: "textSubtle",
                                            children: "(~".concat(totalUSDValue.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }), " USD)")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_15__/* .AutoColumn */ .Tz, {
                        gap: "4px",
                        children: [
                            poolData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                        ref: targetRef,
                                        color: "textSubtle",
                                        small: true,
                                        children: [
                                            t("LP reward APR"),
                                            ":"
                                        ]
                                    }),
                                    tooltipVisible && tooltip,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        children: [
                                            (0,_utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_20__/* .formatAmount */ .d)(poolData.lpApr7d),
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: [
                                            t("Share of Pool"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        children: poolTokenPercentage ? "".concat(poolTokenPercentage.toFixed(6), "%") : "-"
                                    })
                                ]
                            }),
                            isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: [
                                            t("Pooled %asset%", {
                                                asset: currency0.symbol
                                            }),
                                            ":"
                                        ]
                                    }),
                                    token0Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                            ml: "6px",
                                            children: token0Deposited === null || token0Deposited === void 0 ? void 0 : token0Deposited.toSignificant(6)
                                        })
                                    }) : "-"
                                ]
                            }),
                            isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: [
                                            t("Pooled %asset%", {
                                                asset: currency1.symbol
                                            }),
                                            ":"
                                        ]
                                    }),
                                    token1Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                            ml: "6px",
                                            children: token1Deposited === null || token1Deposited === void 0 ? void 0 : token1Deposited.toSignificant(6)
                                        })
                                    }) : "-"
                                ]
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Card__WEBPACK_IMPORTED_MODULE_14__/* .LightCard */ .hl, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                fontSize: "14px",
                style: {
                    textAlign: "center"
                },
                children: t("By adding liquidity you'll earn 0.17% of all trades on this pair proportional to your share of the pool. Fees are added to the pool, accrue in real time and can be claimed by withdrawing your liquidity.")
            })
        })
    });
}
function FullPositionCard(_param) {
    var pair = _param.pair, currency0 = _param.currency0, currency1 = _param.currency1, token0Deposited = _param.token0Deposited, token1Deposited = _param.token1Deposited, totalUSDValue = _param.totalUSDValue, userPoolBalance = _param.userPoolBalance, poolTokenPercentage = _param.poolTokenPercentage, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_param, [
        "pair",
        "currency0",
        "currency1",
        "token0Deposited",
        "token1Deposited",
        "totalUSDValue",
        "userPoolBalance",
        "poolTokenPercentage"
    ]);
    var isStableLP = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* .StableConfigContext */ .UA);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var poolData = (0,_state_swap_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useLPApr */ .aT)(pair);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showMore = ref1[0], setShowMore = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({}, props), {
        style: {
            border: "1px solid #e6e8ec"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                justifyContent: "space-between",
                role: "button",
                onClick: function() {
                    return setShowMore(!showMore);
                },
                p: "16px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                alignItems: "center",
                                mb: "4px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_17__/* .DoubleCurrencyLogo */ .ge, {
                                        currency0: currency0,
                                        currency1: currency1,
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        bold: true,
                                        ml: "8px",
                                        children: !currency0 || !currency1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Loader_Dots__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            children: t("Loading")
                                        }) : "".concat(currency0.symbol, "/").concat(currency1.symbol)
                                    }),
                                    isStableLP ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        ml: "4px",
                                        children: [
                                            " ",
                                            "- Stable"
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: userPoolBalance === null || userPoolBalance === void 0 ? void 0 : userPoolBalance.toSignificant(4)
                            }),
                            Number.isFinite(totalUSDValue) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                small: true,
                                color: "textSubtle",
                                children: "(~".concat(totalUSDValue.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }), " USD)")
                            })
                        ]
                    }),
                    showMore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {})
                ]
            }),
            showMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_15__/* .AutoColumn */ .Tz, {
                gap: "8px",
                style: {
                    padding: "16px"
                },
                children: [
                    isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo_CurrencyLogo__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        size: "20px",
                                        currency: currency0
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        ml: "4px",
                                        children: [
                                            t("Pooled %asset%", {
                                                asset: currency0.symbol
                                            }),
                                            ":"
                                        ]
                                    })
                                ]
                            }),
                            token0Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                    ml: "6px",
                                    children: token0Deposited === null || token0Deposited === void 0 ? void 0 : token0Deposited.toSignificant(6)
                                })
                            }) : "-"
                        ]
                    }),
                    isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo_CurrencyLogo__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        size: "20px",
                                        currency: currency1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        ml: "4px",
                                        children: [
                                            t("Pooled %asset%", {
                                                asset: currency1.symbol
                                            }),
                                            ":"
                                        ]
                                    })
                                ]
                            }),
                            token1Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                    ml: "6px",
                                    children: Number(token1Deposited === null || token1Deposited === void 0 ? void 0 : token1Deposited.toSignificant(6)).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                })
                            }) : "-"
                        ]
                    }),
                    poolData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                        ref: targetRef,
                                        color: "textSubtle",
                                        children: [
                                            t("LP reward APR"),
                                            ":"
                                        ]
                                    }),
                                    tooltipVisible && tooltip
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                children: [
                                    (0,_utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_20__/* .formatAmount */ .d)(poolData.lpApr7d),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                color: "textSubtle",
                                children: t("Share of Pool")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                children: poolTokenPercentage ? "".concat(poolTokenPercentage.toFixed(2) === "0.00" ? "<0.01" : poolTokenPercentage.toFixed(2), "%") : "-"
                            })
                        ]
                    }),
                    userPoolBalance && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThan */ .QA.greaterThan(userPoolBalance.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_9__/* .BIG_INT_ZERO */ .iV) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                style: {
                                    margin: "auto",
                                    borderRadius: "12PX"
                                },
                                as: components_NextLink__WEBPACK_IMPORTED_MODULE_4__/* .NextLinkFromReactRouter */ .a,
                                to: "/remove/".concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_36__/* .currencyId */ .H)(currency0), "/").concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_36__/* .currencyId */ .H)(currency1)).concat(isStableLP ? "?stable=1" : ""),
                                variant: "primary",
                                mb: "8px",
                                scale: "md",
                                children: t("Remove")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                style: {
                                    margin: "auto",
                                    borderRadius: "12PX"
                                },
                                as: components_NextLink__WEBPACK_IMPORTED_MODULE_4__/* .NextLinkFromReactRouter */ .a,
                                to: "/add/".concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_36__/* .currencyId */ .H)(currency0), "/").concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_36__/* .currencyId */ .H)(currency1)),
                                variant: "text",
                                startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                                    color: "primaryBright"
                                }),
                                width: "100%",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                    color: "primaryBright",
                                    fontWeight: "600",
                                    children: [
                                        " ",
                                        t("Add liquidity instead")
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
var MinimalPositionCard = withLPValues(MinimalPositionCardView);
var StableFullPositionCardContainer = withStableLPValues(FullPositionCard);
var StableFullPositionCard = function(props) {
    var ref, ref1;
    var _ref = (0,views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)({
        tokenA: (ref = props.pair) === null || ref === void 0 ? void 0 : ref.token0,
        tokenB: (ref1 = props.pair) === null || ref1 === void 0 ? void 0 : ref1.token1
    }), stableSwapConfig = _ref.stableSwapConfig, config = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_ref, [
        "stableSwapConfig"
    ]);
    if (!stableSwapConfig) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* .StableConfigContext.Provider */ .UA.Provider, {
        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({
            stableSwapConfig: stableSwapConfig
        }, config),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StableFullPositionCardContainer, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({}, props))
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (withLPValues(FullPositionCard));


/***/ }),

/***/ 19639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useTotalSupply */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1505);
/* harmony import */ var _useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91298);
/* harmony import */ var _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(410);




// returns undefined if input token is undefined, or fails to get token contract,
// or contract total supply cannot be fetched
function useTotalSupply(token) {
    var ref, ref1, ref2;
    var contract = (0,_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useTokenContract */ .Ib)((token === null || token === void 0 ? void 0 : token.isToken) ? token.address : undefined, false);
    var totalSupplyStr = (ref = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useSingleCallResult */ .Wk)(contract, "totalSupply")) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.toString();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (token === null || token === void 0 ? void 0 : token.isToken) && totalSupplyStr ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token, totalSupplyStr) : undefined;
    }, [
        token,
        totalSupplyStr
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTotalSupply);


/***/ }),

/***/ 92015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GF": function() { return /* binding */ useBurnActionHandlers; },
/* harmony export */   "Vx": function() { return /* binding */ useDerivedBurnInfo; },
/* harmony export */   "Xi": function() { return /* binding */ useBurnState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97477);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73938);
/* harmony import */ var hooks_usePairs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71633);
/* harmony import */ var hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19639);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68486);
/* harmony import */ var _pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68492);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92328);
/* harmony import */ var _wallet_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5460);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54820);














function useBurnState() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.burn;
    });
}
function useDerivedBurnInfo(currencyA, currencyB, removalCheckedA, removalCheckedB, zapMode) {
    var ref, ref1, ref2;
    var ref3 = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), account = ref3.account, chainId = ref3.chainId;
    var ref4 = useBurnState(), independentField = ref4.independentField, typedValue = ref4.typedValue;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    // pair + totalsupply
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,hooks_usePairs__WEBPACK_IMPORTED_MODULE_5__/* .usePair */ .yX)(currencyA, currencyB), 2), pair = ref5[1];
    // balances
    var relevantTokenBalances = (0,_wallet_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useTokenBalances */ .Z)(account !== null && account !== void 0 ? account : undefined, [
        pair === null || pair === void 0 ? void 0 : pair.liquidityToken
    ]);
    var ref6;
    var userLiquidity = relevantTokenBalances === null || relevantTokenBalances === void 0 ? void 0 : relevantTokenBalances[(ref6 = pair === null || pair === void 0 ? void 0 : (ref = pair.liquidityToken) === null || ref === void 0 ? void 0 : ref.address) !== null && ref6 !== void 0 ? ref6 : ""];
    var ref7 = [
        (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_4__/* .wrappedCurrency */ .pu)(currencyA, chainId),
        (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_4__/* .wrappedCurrency */ .pu)(currencyB, chainId)
    ], tokenA = ref7[0], tokenB = ref7[1];
    var _obj;
    var tokens = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A, tokenA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B, tokenB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY, pair === null || pair === void 0 ? void 0 : pair.liquidityToken), _obj);
    // liquidity values
    var totalSupply = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var liquidityValueA = pair && totalSupply && userLiquidity && tokenA && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalSupply.quotient, userLiquidity.quotient) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenA, pair.getLiquidityValue(tokenA, totalSupply, userLiquidity, false).quotient) : undefined;
    var liquidityValueB = pair && totalSupply && userLiquidity && tokenB && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalSupply.quotient, userLiquidity.quotient) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenB, pair.getLiquidityValue(tokenB, totalSupply, userLiquidity, false).quotient) : undefined;
    var _obj1;
    var liquidityValues = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A, liquidityValueA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B, liquidityValueB), _obj1);
    var percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG("0", "100");
    // user specified a %
    if (independentField === _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT) {
        percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(typedValue, "100");
    } else if (independentField === _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY) {
        if (pair === null || pair === void 0 ? void 0 : pair.liquidityToken) {
            var independentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(typedValue, pair.liquidityToken);
            if (independentAmount && userLiquidity && !independentAmount.greaterThan(userLiquidity)) {
                percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(independentAmount.quotient, userLiquidity.quotient);
            }
        }
    } else if (tokens[independentField]) {
        var independentAmount1 = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(typedValue, tokens[independentField]);
        var liquidityValue = liquidityValues[independentField];
        if (independentAmount1 && liquidityValue && !independentAmount1.greaterThan(liquidityValue)) {
            percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(independentAmount1.quotient, liquidityValue.quotient);
        }
    }
    var liquidityToRemove = userLiquidity && percentToRemove && percentToRemove.greaterThan("0") ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(userLiquidity.currency, percentToRemove.multiply(userLiquidity.quotient).quotient) : undefined;
    var tokenToReceive = removalCheckedA && removalCheckedB ? undefined : removalCheckedA ? (ref1 = tokens[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.address : (ref2 = tokens[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.address;
    var amountA = tokenA && percentToRemove && percentToRemove.greaterThan("0") && liquidityValueA ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenA, percentToRemove.multiply(liquidityValueA.quotient).quotient) : undefined;
    var amountB = tokenB && percentToRemove && percentToRemove.greaterThan("0") && liquidityValueB ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenB, percentToRemove.multiply(liquidityValueB.quotient).quotient) : undefined;
    var tokenAmountToZap = removalCheckedA && removalCheckedB ? undefined : removalCheckedA ? amountB : amountA;
    var estimateZapOutAmount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (pair && tokenAmountToZap) {
            try {
                return pair.getOutputAmount(tokenAmountToZap)[0];
            } catch (error) {
                return undefined;
            }
        }
        return undefined;
    }, [
        pair,
        tokenAmountToZap
    ]);
    var _obj2;
    var parsedAmounts = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, percentToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY, liquidityToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A, !zapMode ? amountA : amountA && removalCheckedA && !removalCheckedB && estimateZapOutAmount ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenA, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.add */ .QA.add(percentToRemove.multiply(liquidityValueA.quotient).quotient, estimateZapOutAmount.quotient)) : !removalCheckedA ? undefined : amountA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B, !zapMode ? amountB : amountB && removalCheckedB && !removalCheckedA && estimateZapOutAmount ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenB, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.add */ .QA.add(percentToRemove.multiply(liquidityValueB.quotient).quotient, estimateZapOutAmount.quotient)) : !removalCheckedB ? undefined : amountB), _obj2);
    var error;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY] || removalCheckedA && !parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A] || removalCheckedB && !parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) {
        error = error !== null && error !== void 0 ? error : t("Enter an amount");
    }
    return {
        pair: pair,
        parsedAmounts: parsedAmounts,
        error: error,
        tokenToReceive: tokenToReceive,
        estimateZapOutAmount: estimateZapOutAmount
    };
}
function useBurnActionHandlers() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_9__/* .useAppDispatch */ .TL)();
    var onUserInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(field, typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_11__/* .typeInput */ .L)({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    return {
        onUserInput: onUserInput
    };
}


/***/ }),

/***/ 50192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OA": function() { return /* binding */ useMintActionHandlers; },
/* harmony export */   "OY": function() { return /* binding */ useMintState; },
/* harmony export */   "Qw": function() { return /* binding */ useDerivedMintInfo; },
/* harmony export */   "eM": function() { return /* binding */ useZapIn; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(828);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(61744);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68486);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1505);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56974);
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75759);
/* harmony import */ var hooks_Trades__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94293);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97477);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91298);
/* harmony import */ var hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19915);
/* harmony import */ var hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71633);
/* harmony import */ var _pancakeswap_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60665);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22408);
/* harmony import */ var hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19639);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9473);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(921);
/* harmony import */ var utils_exchange__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17937);
/* harmony import */ var _pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68492);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(92328);
/* harmony import */ var _wallet_hooks__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5460);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(21568);
























function useMintState() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_13__/* .useSelector */ .v9)(function(state) {
        return state.mint;
    });
}
function useMintActionHandlers(noLiquidity) {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_17__/* .useAppDispatch */ .TL)();
    var onFieldAInput = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function(typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_19__/* .typeInput */ .LC)({
            field: _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    var onFieldBInput = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function(typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_19__/* .typeInput */ .LC)({
            field: _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    return {
        onFieldAInput: onFieldAInput,
        onFieldBInput: onFieldBInput
    };
}
function useDerivedMintInfo(currencyA, currencyB) {
    var ref, ref1, ref2, ref3;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().account;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref4 = useMintState(), independentField = ref4.independentField, typedValue = ref4.typedValue, otherTypedValue = ref4.otherTypedValue;
    var dependentField = independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    // tokens
    var currencies = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    // pair
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .usePair */ .yX)(currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]), 2), pairState = ref5[0], pair = ref5[1];
    var totalSupply = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var noLiquidity = pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .PairState.NOT_EXISTS */ ._G.NOT_EXISTS || Boolean(totalSupply && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.equal */ .QA.equal(totalSupply.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__/* .BIG_INT_ZERO */ .iV)) || Boolean(pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .PairState.EXISTS */ ._G.EXISTS && pair && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.equal */ .QA.equal(pair.reserve0.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__/* .BIG_INT_ZERO */ .iV) && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.equal */ .QA.equal(pair.reserve1.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_2__/* .BIG_INT_ZERO */ .iV));
    // balances
    var balances = (0,_wallet_hooks__WEBPACK_IMPORTED_MODULE_18__/* .useCurrencyBalances */ .K5)(account !== null && account !== void 0 ? account : undefined, [
        currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A],
        currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B], 
    ]);
    var _obj;
    var currencyBalances = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, balances[0]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, balances[1]), _obj);
    // amounts
    var independentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(typedValue, currencies[independentField]);
    var dependentAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (noLiquidity) {
            if (otherTypedValue && currencies[dependentField]) {
                return (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(otherTypedValue, currencies[dependentField]);
            }
            return undefined;
        }
        if (independentAmount) {
            // we wrap the currencies just to get the price in terms of the other token
            var wrappedIndependentAmount = independentAmount === null || independentAmount === void 0 ? void 0 : independentAmount.wrapped;
            var ref = [
                currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
                currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return (dependentCurrency === null || dependentCurrency === void 0 ? void 0 : dependentCurrency.isNative) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(dependentCurrency, dependentTokenAmount.quotient) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        noLiquidity,
        otherTypedValue,
        currencies,
        dependentField,
        independentAmount,
        currencyA,
        currencyB,
        pair
    ]);
    var parsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField
    ]);
    var price = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (noLiquidity) {
            var currencyAAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencyBAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
            if (currencyAAmount && currencyBAmount) {
                return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA(currencyAAmount.currency, currencyBAmount.currency, currencyAAmount.quotient, currencyBAmount.quotient);
            }
            return undefined;
        }
        var wrappedCurrencyA = currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped;
        return pair && wrappedCurrencyA ? pair.priceOf(wrappedCurrencyA) : undefined;
    }, [
        currencyA,
        noLiquidity,
        pair,
        parsedAmounts
    ]);
    // liquidity minted
    var liquidityMinted = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var currencyAAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencyBAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
        var ref = [
            currencyAAmount === null || currencyAAmount === void 0 ? void 0 : currencyAAmount.wrapped,
            currencyBAmount === null || currencyBAmount === void 0 ? void 0 : currencyBAmount.wrapped
        ], tokenAmountA = ref[0], tokenAmountB = ref[1];
        if (pair && totalSupply && tokenAmountA && tokenAmountB) {
            try {
                return pair.getLiquidityMinted(totalSupply, tokenAmountA, tokenAmountB);
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        parsedAmounts,
        pair,
        totalSupply
    ]);
    var poolTokenPercentage = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Percent */ .gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var error;
    var addError;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (pairState === hooks_usePairs__WEBPACK_IMPORTED_MODULE_8__/* .PairState.INVALID */ ._G.INVALID) {
        error = error !== null && error !== void 0 ? error : t("Choose a valid pair");
    }
    var currencyAAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A], currencyBAmount = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
    if (currencyAAmount && currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.equalTo(0)) && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.equalTo(0))) {
        error = error !== null && error !== void 0 ? error : t("No token balance");
    }
    if (!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] || !parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) {
        addError = t("Enter an amount");
    }
    if (currencyAAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(currencyAAmount))) {
        var ref6;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref6 = currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref6 === void 0 ? void 0 : ref6.symbol
        });
    }
    if (currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref3 = currencyBalances[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(currencyBAmount))) {
        var ref7;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref7 = currencies[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref7 === void 0 ? void 0 : ref7.symbol
        });
    }
    return {
        dependentField: dependentField,
        currencies: currencies,
        pair: pair,
        pairState: pairState,
        currencyBalances: currencyBalances,
        parsedAmounts: parsedAmounts,
        price: price,
        noLiquidity: noLiquidity,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        error: error,
        addError: addError
    };
}
var MAX_ZAP_REVERSE_RATIO = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.BigInt */ .QA.BigInt(50);
var getMaxZapSwapAmount = function(pair, tokenZap) {
    return pair && tokenZap && pair.involvesToken(tokenZap) && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.divide */ .QA.divide(pair.reserveOf(tokenZap).quotient, MAX_ZAP_REVERSE_RATIO);
};
// simplify version to guess the zap in amount by swapInAmount from max zap reserves ratio 50
function guessMaxZappableAmount(pair, token0AmountIn, token1AmountIn) {
    if (!token1AmountIn) {
        if (token0AmountIn) {
            var maxSwapAmount = getMaxZapSwapAmount(pair, token0AmountIn.currency);
            return maxSwapAmount && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(maxSwapAmount, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.BigInt */ .QA.BigInt(2));
        }
        return undefined;
    }
    if (token0AmountIn && token1AmountIn) {
        var maxSwapAmount1 = getMaxZapSwapAmount(pair, token0AmountIn.currency);
        if (!maxSwapAmount1) {
            return undefined;
        }
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(pair.getInputAmount(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token0AmountIn.currency, maxSwapAmount1)), 2), _ = ref[0], newPair = ref[1];
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.add */ .QA.add(maxSwapAmount1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.divide */ .QA.divide(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(token1AmountIn.quotient, newPair.reserveOf(token0AmountIn.currency).quotient), newPair.reserveOf(token1AmountIn.currency).quotient));
    }
    return undefined;
}
// compare the gas is larger than swap in amount
function useZapInGasOverhead(inputAmount) {
    var ref;
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useGasPrice */ .Fh)();
    var native = (0,hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var requiredGas = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_22__.formatUnits)(gasPrice ? _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_23__/* .BigNumber.from */ .O$.from(gasPrice).mul("500000") : "0");
    var requiredGasAsCurrencyAmount = inputAmount ? (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(requiredGas, native) : undefined;
    var inputIsBNB = (inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency.symbol) === "BNB";
    var gasCostInInputTokens = (0,hooks_Trades__WEBPACK_IMPORTED_MODULE_4__/* .useTradeExactIn */ .AU)(requiredGasAsCurrencyAmount, inputIsBNB ? null : inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency);
    var ref1;
    return (ref1 = gasCostInInputTokens === null || gasCostInInputTokens === void 0 ? void 0 : (ref = gasCostInInputTokens.outputAmount) === null || ref === void 0 ? void 0 : ref.greaterThan(inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.quotient)) !== null && ref1 !== void 0 ? ref1 : false;
}
function useZapIn(param) {
    var canZap = param.canZap, currencyA = param.currencyA, currencyB = param.currencyB, pair = param.pair, currencyBalances = param.currencyBalances, zapTokenCheckedA = param.zapTokenCheckedA, zapTokenCheckedB = param.zapTokenCheckedB, maxAmounts = param.maxAmounts;
    var ref, ref1, ref2, ref3;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false), inputBlurOnce = ref4[0], setInputBlurOnce = ref4[1];
    var previousBlur = (0,_pancakeswap_hooks__WEBPACK_IMPORTED_MODULE_9__/* .usePreviousValue */ .zP)(inputBlurOnce);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false), triedAutoReduce = ref5[0], setTriedAutoReduce = ref5[1];
    var ref6 = useMintState(), independentField = ref6.independentField, typedValue = ref6.typedValue;
    var dependentField = independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    var currencies = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    var independentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(typedValue, currencies[independentField]);
    var _dependentAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!canZap) {
            return undefined;
        }
        if (independentAmount) {
            var wrappedIndependentAmount = independentAmount === null || independentAmount === void 0 ? void 0 : independentAmount.wrapped;
            var ref = [
                currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
                currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return dependentCurrency.isNative ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(dependentCurrency, dependentTokenAmount.quotient) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        canZap,
        currencyA,
        currencyB,
        dependentField,
        independentAmount,
        pair
    ]);
    var isDependentAmountGreaterThanMaxAmount = maxAmounts[dependentField] && _dependentAmount && (_dependentAmount === null || _dependentAmount === void 0 ? void 0 : _dependentAmount.greaterThan(maxAmounts[dependentField]));
    // amounts
    var dependentAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return isDependentAmountGreaterThanMaxAmount ? maxAmounts[dependentField] : _dependentAmount;
    }, [
        isDependentAmountGreaterThanMaxAmount,
        maxAmounts,
        dependentField,
        _dependentAmount
    ]);
    var parsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, !zapTokenCheckedA ? undefined : independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, !zapTokenCheckedB ? undefined : independentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField,
        zapTokenCheckedA,
        zapTokenCheckedB
    ]);
    var wrappedParsedAmounts = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var ref, ref1;
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A, (ref = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.wrapped), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B, (ref1 = parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.wrapped), _obj;
    }, [
        parsedAmounts
    ]);
    var zapContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_6__/* .useZapContract */ .n9)();
    var rebalancing = !!zapTokenCheckedA && !!zapTokenCheckedB && !!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] && !!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B];
    var singleTokenToZapField = !rebalancing && zapTokenCheckedB && !!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B] ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    var singleTokenToZapAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return wrappedParsedAmounts[singleTokenToZapField];
    }, [
        singleTokenToZapField,
        wrappedParsedAmounts
    ]);
    var noNeedZap = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!rebalancing) {
            return false;
        }
        if (!wrappedParsedAmounts[independentField] || !wrappedParsedAmounts[dependentField]) {
            return undefined;
        }
        if (!isDependentAmountGreaterThanMaxAmount) {
            return true;
        }
        var ref = [
            currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
            currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
        ], tokenA = ref[0], tokenB = ref[1];
        if (tokenA && tokenB && wrappedParsedAmounts[independentField] && pair) {
            return wrappedParsedAmounts[dependentField].equalTo(dependentField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedParsedAmounts[independentField]) : pair.priceOf(tokenB).quote(wrappedParsedAmounts[independentField]));
        }
        return undefined;
    }, [
        currencyA,
        currencyB,
        dependentField,
        independentField,
        isDependentAmountGreaterThanMaxAmount,
        pair,
        rebalancing,
        wrappedParsedAmounts, 
    ]);
    var singleZapEstimate = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_10__/* .useSWRContract */ .Av)(canZap && !noNeedZap && zapContract && singleTokenToZapAmount && (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency) && pair && !rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInSwap",
        params: [
            singleTokenToZapAmount.currency.address,
            singleTokenToZapAmount.quotient.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var rebalancingZapEstimate = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_10__/* .useSWRContract */ .Av)(canZap && zapContract && !noNeedZap && wrappedParsedAmounts && wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] && wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B] && pair && rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInRebalancingSwap",
        params: [
            wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].currency.address,
            wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B].currency.address,
            wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].quotient.toString(),
            (ref = wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : (ref1 = ref.quotient) === null || ref1 === void 0 ? void 0 : ref1.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var zapInEstimated = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return ((rebalancingZapEstimate === null || rebalancingZapEstimate === void 0 ? void 0 : rebalancingZapEstimate.data) || (singleZapEstimate === null || singleZapEstimate === void 0 ? void 0 : singleZapEstimate.data)) && {
            swapAmountIn: rebalancing ? (ref = rebalancingZapEstimate.data) === null || ref === void 0 ? void 0 : ref.swapAmountIn : (ref1 = singleZapEstimate.data) === null || ref1 === void 0 ? void 0 : ref1.swapAmountIn,
            swapAmountOut: rebalancing ? (ref2 = rebalancingZapEstimate.data) === null || ref2 === void 0 ? void 0 : ref2.swapAmountOut : (ref3 = singleZapEstimate.data) === null || ref3 === void 0 ? void 0 : ref3.swapAmountOut,
            isToken0Sold: rebalancing ? (ref4 = rebalancingZapEstimate.data) === null || ref4 === void 0 ? void 0 : ref4.sellToken0 : ((ref5 = singleZapEstimate.data) === null || ref5 === void 0 ? void 0 : ref5.swapTokenOut) === (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency.address)
        };
    }, [
        rebalancing,
        rebalancingZapEstimate.data,
        singleZapEstimate.data,
        singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.currency.address
    ]);
    var rebalancingSellToken0 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (rebalancingZapEstimate.data) {
            return rebalancingZapEstimate.data.sellToken0;
        }
        if (!pair || !wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A] || !wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B]) {
            return undefined;
        }
        var token0toZap = pair.token0.equals(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].currency);
        if (token0toZap) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].quotient, pair.reserve1.quotient), _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B].quotient, pair.reserve0.quotient));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B].quotient, pair.reserve0.quotient), _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.multiply */ .QA.multiply(wrappedParsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A].quotient, pair.reserve1.quotient));
    }, [
        pair,
        rebalancingZapEstimate.data,
        wrappedParsedAmounts
    ]);
    var swapTokenField = !rebalancing ? singleTokenToZapField : rebalancingSellToken0 ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B;
    var swapOutTokenField = swapTokenField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A ? _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_B */ .gN.CURRENCY_B : _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A;
    var swapTokens = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        var ref, ref1;
        var _obj;
        return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, swapTokenField, (ref = currencies[swapTokenField]) === null || ref === void 0 ? void 0 : ref.wrapped), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, swapOutTokenField, (ref1 = currencies[swapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.wrapped), _obj;
    }, [
        currencies,
        swapOutTokenField,
        swapTokenField
    ]);
    var zapInEstimatedError = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.error : singleZapEstimate.error;
    }, [
        rebalancing,
        rebalancingZapEstimate.error,
        singleZapEstimate.error
    ]);
    var zapInEstimatedStatus = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.status : singleZapEstimate.status;
    }, [
        rebalancing,
        rebalancingZapEstimate.status,
        singleZapEstimate.status
    ]);
    var priceImpact = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!zapInEstimated) {
            return undefined;
        }
        var tokenAmountIn = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString());
        var tokenAmountOut = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
        var midPrice = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA(swapTokens[swapTokenField], swapTokens[swapOutTokenField], pair.token0.equals(swapTokens[swapTokenField]) ? pair.reserve0.quotient : pair.reserve1.quotient, pair.token0.equals(swapTokens[swapTokenField]) ? pair.reserve1.quotient : pair.reserve0.quotient);
        return (0,_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .computePriceImpact */ .oc)(midPrice, tokenAmountIn, tokenAmountOut);
    }, [
        pair,
        swapOutTokenField,
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]);
    var overLimitZapRatio = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!zapInEstimated) {
            return false;
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.lessThan */ .QA.lessThan(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.divide */ .QA.divide(pair.reserveOf(swapTokens[swapTokenField]).quotient, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.BigInt */ .QA.BigInt(zapInEstimated.swapAmountIn.toString())), MAX_ZAP_REVERSE_RATIO);
    }, [
        pair,
        swapTokens,
        zapInEstimated,
        swapTokenField
    ]);
    var priceSeverity = overLimitZapRatio || zapInEstimatedError ? 4 : priceImpact ? (0,utils_exchange__WEBPACK_IMPORTED_MODULE_15__/* .warningSeverity */ .oX)(priceImpact) : 0;
    var ref7 = useMintActionHandlers(false), onFieldAInput = ref7.onFieldAInput, onFieldBInput = ref7.onFieldBInput;
    var maxZappableAmount = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return guessMaxZappableAmount(pair, wrappedParsedAmounts[swapTokenField], rebalancing ? wrappedParsedAmounts[swapOutTokenField] : undefined);
    }, [
        pair,
        wrappedParsedAmounts,
        swapTokenField,
        rebalancing,
        swapOutTokenField
    ]);
    var convertToMaxZappable = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function() {
        if (maxZappableAmount) {
            if (maxAmounts[swapTokenField]) {
                var ref;
                var formatInput = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_22__.formatUnits)(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(maxAmounts[swapTokenField].quotient, maxZappableAmount) ? maxZappableAmount.toString() : maxAmounts[swapTokenField].quotient.toString(), (ref = maxAmounts[swapTokenField]) === null || ref === void 0 ? void 0 : ref.currency.decimals);
                if (swapTokenField === _actions__WEBPACK_IMPORTED_MODULE_19__/* .Field.CURRENCY_A */ .gN.CURRENCY_A) {
                    onFieldAInput(formatInput);
                } else {
                    onFieldBInput(formatInput);
                }
            }
        }
    }, [
        maxAmounts,
        maxZappableAmount,
        onFieldAInput,
        onFieldBInput,
        swapTokenField
    ]);
    var totalSupply = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    // liquidity minted
    var liquidityMinted = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (!pair || !swapTokens[swapTokenField] || !swapTokens[swapOutTokenField] || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn) || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut) || !wrappedParsedAmounts[swapTokenField]) {
            return undefined;
        }
        if (pair && totalSupply) {
            try {
                // calc the tokenA amount after swap
                var zappedTokenAmountA = wrappedParsedAmounts[swapTokenField].greaterThan(zapInEstimated.swapAmountIn.toString()) ? wrappedParsedAmounts[swapTokenField].subtract(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString())) : wrappedParsedAmounts[swapTokenField];
                var zappedTokenAmountB = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
                if (wrappedParsedAmounts[swapOutTokenField]) {
                    zappedTokenAmountB = zappedTokenAmountB.add(wrappedParsedAmounts[swapOutTokenField]);
                }
                var lpMinted = pair.getLiquidityMinted(totalSupply, zappedTokenAmountA, zappedTokenAmountB);
                return lpMinted;
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        pair,
        swapTokens,
        swapTokenField,
        swapOutTokenField,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut,
        wrappedParsedAmounts,
        totalSupply, 
    ]);
    var swapTokenAmountTooLow = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return wrappedParsedAmounts[swapTokenField] && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.lessThan */ .QA.lessThan(wrappedParsedAmounts[swapTokenField].quotient, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .MINIMUM_LIQUIDITY */ .Xh);
    }, [
        swapTokenField,
        wrappedParsedAmounts
    ]);
    var swapOutAmountTooLow = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return wrappedParsedAmounts[swapOutTokenField] && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.lessThan */ .QA.lessThan(wrappedParsedAmounts[swapOutTokenField].quotient, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .MINIMUM_LIQUIDITY */ .Xh);
    }, [
        swapOutTokenField,
        wrappedParsedAmounts
    ]);
    var poolTokenPercentage = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Percent */ .gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var gasOverhead = useZapInGasOverhead((0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return zapInEstimated ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString()) : null;
    }, [
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]));
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
        if (!triedAutoReduce && parsedAmounts[swapTokenField] && maxZappableAmount && !previousBlur && inputBlurOnce && !rebalancing) {
            if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .JSBI.greaterThan */ .QA.greaterThan(parsedAmounts[swapTokenField].quotient, maxZappableAmount)) {
                convertToMaxZappable();
                setTriedAutoReduce(true);
            }
        }
    }, [
        convertToMaxZappable,
        inputBlurOnce,
        maxZappableAmount,
        parsedAmounts,
        previousBlur,
        rebalancing,
        singleTokenToZapAmount,
        swapTokenField,
        triedAutoReduce, 
    ]);
    var onInputBlurOnce = (0,react__WEBPACK_IMPORTED_MODULE_12__.useCallback)(function() {
        setInputBlurOnce(true);
    }, []);
    var error;
    if (zapInEstimatedError) {
        error = t("Cannot estimate zap amount");
    }
    if (swapTokenAmountTooLow || rebalancing && swapOutAmountTooLow) {
        error = t("Zap in amount too low");
    }
    if (wrappedParsedAmounts[swapTokenField] && ((ref2 = currencyBalances[swapTokenField]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(wrappedParsedAmounts[swapTokenField]))) {
        var ref8;
        var _symbol;
        error = t("Insufficient %token% balance", {
            token: (_symbol = (ref8 = wrappedParsedAmounts[swapTokenField]) === null || ref8 === void 0 ? void 0 : ref8.currency.symbol) !== null && _symbol !== void 0 ? _symbol : ""
        });
    }
    if (wrappedParsedAmounts[swapOutTokenField] && rebalancing && ((ref3 = currencyBalances[swapOutTokenField]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(wrappedParsedAmounts[swapOutTokenField]))) {
        var ref9;
        var _symbol1;
        error = t("Insufficient %token% balance", {
            token: (_symbol1 = (ref9 = wrappedParsedAmounts[swapOutTokenField]) === null || ref9 === void 0 ? void 0 : ref9.currency.symbol) !== null && _symbol1 !== void 0 ? _symbol1 : ""
        });
    }
    return {
        zapInEstimating: zapInEstimatedStatus !== config_constants_types__WEBPACK_IMPORTED_MODULE_3__/* .FetchStatus.Fetched */ .iF.Fetched,
        zapInEstimatedError: zapInEstimatedError,
        zapInEstimated: zapInEstimated,
        error: error,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        parsedAmounts: parsedAmounts,
        swapTokenField: swapTokenField,
        swapOutTokenField: swapOutTokenField,
        priceSeverity: priceSeverity,
        convertToMaxZappable: convertToMaxZappable,
        rebalancing: rebalancing,
        noNeedZap: noNeedZap,
        gasOverhead: gasOverhead,
        isDependentAmountGreaterThanMaxAmount: isDependentAmountGreaterThanMaxAmount,
        onInputBlurOnce: onInputBlurOnce
    };
}


/***/ }),

/***/ 59604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ formatAmount; }
/* harmony export */ });
/* unused harmony export getFirstThreeNonZeroDecimals */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

// Returns first 2 digits after first non-zero decimal
// i.e. 0.001286 -> 0.0012, 0.9845 -> 0.98, 0.0102 -> 0.010, etc
// Intended to be used for tokens whose value is less than $1
// https://stackoverflow.com/a/23887837
var getFirstThreeNonZeroDecimals = function(value) {
    return value.toFixed(9).match(/^-?\d*\.?0*\d{0,2}/)[0];
};
/**
 * This function is used to format token prices, liquidity, amount of tokens in TX, and in general any numbers on info section
 * @param amount - amount to be formatted
 * @param notation - whether to show 1M or 1,000,000
 * @param displayThreshold - threshold below which it will return simply <displayThreshold instead of actual value, e.g. if 0.001 -> returns <0.001 for 0.0005
 * @param tokenPrecision - set to true when you want precision to be 3 decimals for values < 1 and 2 decimals for values > 1
 * @param isInteger - if true the values will contain decimal part only if the amount is > 1000
 * @returns formatted string ready to be displayed
 */ var formatAmount = function(amount, options) {
    var ref = options || {
        notation: amount >= 10000 ? "compact" : "standard"
    }, _notation = ref.notation, notation = _notation === void 0 ? amount >= 10000 ? "compact" : "standard" : _notation, displayThreshold = ref.displayThreshold, tokenPrecision = ref.tokenPrecision, isInteger = ref.isInteger;
    if (amount === 0) {
        if (isInteger) {
            return "0";
        }
        return "0.00";
    }
    if (!amount) return "-";
    if (displayThreshold && amount < displayThreshold) {
        return "<".concat(displayThreshold);
    }
    if (amount < 1 && !tokenPrecision) {
        return getFirstThreeNonZeroDecimals(amount);
    }
    var precision = 2;
    if (tokenPrecision) {
        precision = amount < 1 ? 3 : 2;
    }
    var format = "0.".concat("0".repeat(precision), "a");
    if (notation === "standard") {
        format = "0,0.".concat("0".repeat(precision));
    }
    if (isInteger && amount < 1000) {
        format = "0";
    }
    var amountWithPrecision = parseFloat(amount.toFixed(precision));
    // toUpperCase is needed cause numeral doesn't have support for capital K M B out of the box
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(amountWithPrecision).format(format).toUpperCase();
};


/***/ }),

/***/ 34934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ useStableLPDerivedMintInfo; },
  "o": function() { return /* binding */ useStablePair; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(1505);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(71633);
// EXTERNAL MODULE: ./src/hooks/useTotalSupply.ts
var useTotalSupply = __webpack_require__(19639);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(68492);
// EXTERNAL MODULE: ./src/state/mint/actions.ts
var actions = __webpack_require__(21568);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(5460);
// EXTERNAL MODULE: ./src/views/Swap/StableSwap/hooks/useStableConfig.ts + 3 modules
var useStableConfig = __webpack_require__(12353);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/views/Swap/StableSwap/hooks/useStableTradeExactIn.ts








var maximumAmountInFactory = function(currencyAmountIn, slippageTolerance) {
    var slippageAdjustedAmountIn = new Fraction(ONE).add(slippageTolerance).multiply(currencyAmountIn.quotient).quotient;
    return CurrencyAmount.fromRawAmount(currencyAmountIn.currency, slippageAdjustedAmountIn);
};
var minimumAmountOutFactory = function(currencyAmountOut, slippageTolerance) {
    var slippageAdjustedAmountOut = new Fraction(ONE).add(slippageTolerance).invert().multiply(currencyAmountOut.quotient).quotient;
    return CurrencyAmount.fromRawAmount(currencyAmountOut.currency, slippageAdjustedAmountOut);
};
function useStableTradeResponse(param) {
    var currencyAmountIn = param.currencyAmountIn, currencyAmountOut = param.currencyAmountOut, stableSwapConfig = param.stableSwapConfig, tradeType = param.tradeType;
    var maximumAmountIn = useCallback(function(slippageTolerance) {
        if (tradeType === TradeType.EXACT_INPUT) {
            return currencyAmountIn;
        }
        return currencyAmountIn ? maximumAmountInFactory(currencyAmountIn, slippageTolerance) : CurrencyAmount.fromRawAmount(currencyAmountIn.currency, "0");
    }, [
        currencyAmountIn,
        tradeType
    ]);
    var minimumAmountOut = useCallback(function(slippageTolerance) {
        if (tradeType === TradeType.EXACT_OUTPUT) {
            return currencyAmountOut;
        }
        return currencyAmountOut ? minimumAmountOutFactory(currencyAmountOut, slippageTolerance) : CurrencyAmount.fromRawAmount(currencyAmountOut.currency, "0");
    }, [
        currencyAmountOut,
        tradeType
    ]);
    var isInvalid = !currencyAmountIn || !currencyAmountOut || !stableSwapConfig || !currencyAmountIn;
    var executionPrice = useMemo(function() {
        if (isInvalid) return null;
        return new Price(currencyAmountIn.currency, currencyAmountOut.currency, currencyAmountIn.quotient, currencyAmountOut.quotient);
    }, [
        isInvalid,
        currencyAmountIn,
        currencyAmountOut
    ]);
    if (isInvalid) return null;
    return {
        tradeType: TradeType.EXACT_INPUT,
        inputAmount: currencyAmountIn,
        outputAmount: currencyAmountOut,
        executionPrice: executionPrice,
        priceImpact: null,
        maximumAmountIn: maximumAmountIn,
        minimumAmountOut: minimumAmountOut
    };
}
function useEstimatedAmount(param) {
    var estimatedCurrency = param.estimatedCurrency, stableSwapConfig = param.stableSwapConfig, quotient = param.quotient, stableSwapContract = param.stableSwapContract;
    var deferQuotient = (0,react.useDeferredValue)(quotient);
    return (0,dist/* default */.ZP)((stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress) && estimatedCurrency && !!deferQuotient ? [
        "swapContract",
        stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress,
        deferQuotient
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _stableSwapContract, ref, isToken0, args, estimatedAmount;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isToken0 = (stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : (ref = stableSwapConfig.token0) === null || ref === void 0 ? void 0 : ref.address) === (estimatedCurrency === null || estimatedCurrency === void 0 ? void 0 : estimatedCurrency.address);
                    args = isToken0 ? [
                        1,
                        0,
                        deferQuotient
                    ] : [
                        0,
                        1,
                        deferQuotient
                    ];
                    return [
                        4,
                        (_stableSwapContract = stableSwapContract).get_dy.apply(_stableSwapContract, (0,_to_consumable_array/* default */.Z)(args))
                    ];
                case 1:
                    estimatedAmount = _state.sent();
                    return [
                        2,
                        swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(estimatedCurrency, estimatedAmount)
                    ];
            }
        });
    }), {
        use: [
            useSWRContract/* laggyMiddleware */.XS
        ]
    });
}
/**
 * Returns the best trade for the exact amount of tokens in to the given token out
 */ function useStableTradeExactIn(currencyAmountIn, currencyOut) {
    var ref;
    var ref1 = useContext(StableConfigContext), stableSwapContract = ref1.stableSwapContract, stableSwapConfig = ref1.stableSwapConfig;
    var currencyAmountInQuotient = currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : (ref = currencyAmountIn.quotient) === null || ref === void 0 ? void 0 : ref.toString();
    var ref2 = useEstimatedAmount({
        estimatedCurrency: currencyOut,
        quotient: currencyAmountInQuotient,
        stableSwapContract: stableSwapContract,
        stableSwapConfig: stableSwapConfig
    }), currencyAmountOut = ref2.data;
    return useStableTradeResponse({
        currencyAmountIn: currencyAmountIn,
        currencyAmountOut: currencyAmountOut,
        stableSwapConfig: stableSwapConfig,
        tradeType: TradeType.EXACT_INPUT
    });
}

// EXTERNAL MODULE: ./src/state/mint/hooks.ts
var mint_hooks = __webpack_require__(50192);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/AddStableLiquidity/hooks/useStableLPDerivedMintInfo.tsx

















function useStablePair(currencyA, currencyB) {
    var ref;
    var ref1 = (0,react.useContext)(useStableConfig/* StableConfigContext */.UA), stableSwapConfig = ref1.stableSwapConfig, stableSwapContract = ref1.stableSwapContract;
    var currencyAAmountQuotient = (ref = (0,tryParseAmount/* default */.Z)("1", currencyA)) === null || ref === void 0 ? void 0 : ref.quotient;
    var ref2 = useEstimatedAmount({
        estimatedCurrency: currencyB,
        quotient: currencyAAmountQuotient === null || currencyAAmountQuotient === void 0 ? void 0 : currencyAAmountQuotient.toString(),
        stableSwapContract: stableSwapContract,
        stableSwapConfig: stableSwapConfig
    }), estimatedToken1Amount = ref2.data;
    var pair = (0,react.useMemo)(function() {
        var isPriceValid = currencyAAmountQuotient && estimatedToken1Amount;
        var ZERO_AMOUNT = swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(currencyB, "0");
        var token0Price = isPriceValid ? new swap_sdk_src/* Price */.tA(currencyA, currencyB, currencyAAmountQuotient, estimatedToken1Amount.quotient) : ZERO_AMOUNT;
        return {
            liquidityToken: (stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.liquidityToken) || null,
            tokenAmounts: [],
            token0: currencyA,
            token1: currencyB,
            priceOf: function(token) {
                return isPriceValid ? (token === null || token === void 0 ? void 0 : token.address) === (currencyA === null || currencyA === void 0 ? void 0 : currencyA.address) ? token0Price : token0Price.invert() : ZERO_AMOUNT;
            },
            token0Price: function() {
                return token0Price;
            },
            token1Price: function() {
                return token0Price.invert();
            },
            // NOTE: Stable Tokens don't need this
            reserve1: ZERO_AMOUNT,
            reserve0: ZERO_AMOUNT,
            getLiquidityValue: function() {
                return ZERO_AMOUNT;
            }
        };
    }, [
        stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.liquidityToken,
        currencyA,
        currencyB,
        currencyAAmountQuotient,
        estimatedToken1Amount
    ]);
    if (!stableSwapConfig) {
        return {
            pairState: usePairs/* PairState.NOT_EXISTS */._G.NOT_EXISTS,
            pair: undefined
        };
    }
    return {
        pairState: usePairs/* PairState.EXISTS */._G.EXISTS,
        pair: pair
    };
}
function useMintedStabelLP(param) {
    var stableSwapInfoContract = param.stableSwapInfoContract, stableSwapConfig = param.stableSwapConfig, stableSwapAddress = param.stableSwapAddress, currencyInput = param.currencyInput, currencyInputAmount = param.currencyInputAmount, currencyOutputAmount = param.currencyOutputAmount;
    var quotient0Str = currencyInputAmount === null || currencyInputAmount === void 0 ? void 0 : currencyInputAmount.toString();
    var quotient1Str = currencyOutputAmount === null || currencyOutputAmount === void 0 ? void 0 : currencyOutputAmount.toString();
    var isValid = !!stableSwapAddress && !!quotient0Str && !!quotient1Str;
    return (0,dist/* default */.ZP)(isValid ? [
        "get_add_liquidity_mint_amount",
        stableSwapAddress,
        quotient0Str,
        quotient1Str
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, isToken0, amounts;
        return (0,tslib_es6.__generator)(this, function(_state) {
            isToken0 = (stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : (ref = stableSwapConfig.token0) === null || ref === void 0 ? void 0 : ref.address) === (currencyInput === null || currencyInput === void 0 ? void 0 : currencyInput.address);
            amounts = isToken0 ? [
                quotient0Str,
                quotient1Str
            ] : [
                quotient1Str,
                quotient0Str
            ];
            return [
                2,
                stableSwapInfoContract.get_add_liquidity_mint_amount(stableSwapAddress, amounts)
            ];
        });
    }));
}
function useStableLPDerivedMintInfo(currencyA, currencyB) {
    var ref, ref1, ref2, ref3;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref4 = (0,mint_hooks/* useMintState */.OY)(), independentField = ref4.independentField, typedValue = ref4.typedValue, otherTypedValue = ref4.otherTypedValue;
    var dependentField = independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    // tokens
    var currencies = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    // pair
    var ref5 = useStablePair(currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped, currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped), pairState = ref5.pairState, pair = ref5.pair;
    var totalSupply = (0,useTotalSupply/* default */.Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var noLiquidity = pairState === usePairs/* PairState.NOT_EXISTS */._G.NOT_EXISTS || Boolean(totalSupply && swap_sdk_src/* JSBI.equal */.QA.equal(totalSupply.quotient, exchange/* BIG_INT_ZERO */.iV));
    // balances
    var balances = (0,hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        currencyA,
        currencyB
    ]);
    var _obj;
    var currencyBalances = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, balances[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, balances[1]), _obj);
    // amounts
    var independentAmount = (0,tryParseAmount/* default */.Z)(typedValue, currencies[independentField]);
    var dependentAmount = (0,tryParseAmount/* default */.Z)(otherTypedValue, currencies[dependentField]);
    var parsedAmounts = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField
    ]);
    var ref6 = (0,react.useContext)(useStableConfig/* StableConfigContext */.UA), stableSwapConfig = ref6.stableSwapConfig, stableSwapContract = ref6.stableSwapContract, stableSwapInfoContract = ref6.stableSwapInfoContract;
    var currencyAAmount = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencyBAmount = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    var currencyAAmountQuotient = currencyAAmount === null || currencyAAmount === void 0 ? void 0 : currencyAAmount.quotient;
    var currencyBAmountQuotient = currencyBAmount === null || currencyBAmount === void 0 ? void 0 : currencyBAmount.quotient;
    var ref7 = useEstimatedAmount({
        estimatedCurrency: currencyAAmountQuotient ? currencyB : currencyA,
        quotient: currencyAAmountQuotient ? currencyAAmountQuotient === null || currencyAAmountQuotient === void 0 ? void 0 : currencyAAmountQuotient.toString() : currencyBAmountQuotient === null || currencyBAmountQuotient === void 0 ? void 0 : currencyBAmountQuotient.toString(),
        stableSwapConfig: stableSwapConfig,
        stableSwapContract: stableSwapContract
    }), estimatedOutputAmount = ref7.data;
    var price = (0,react.useMemo)(function() {
        var isEstimatedOutputAmountZero = estimatedOutputAmount === null || estimatedOutputAmount === void 0 ? void 0 : estimatedOutputAmount.equalTo(0);
        if ((currencyAAmountQuotient || currencyBAmountQuotient) && estimatedOutputAmount && !isEstimatedOutputAmountZero) {
            return currencyAAmountQuotient ? new swap_sdk_src/* Price */.tA(currencyA, currencyB, currencyAAmountQuotient, estimatedOutputAmount.quotient) : new swap_sdk_src/* Price */.tA(currencyA, currencyB, estimatedOutputAmount.quotient, currencyBAmountQuotient);
        }
        return undefined;
    }, [
        estimatedOutputAmount,
        currencyA,
        currencyB,
        currencyBAmountQuotient,
        currencyAAmountQuotient
    ]);
    var ref8 = useMintedStabelLP({
        stableSwapAddress: stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress,
        stableSwapInfoContract: stableSwapInfoContract,
        stableSwapConfig: stableSwapConfig,
        currencyInput: currencyAAmountQuotient ? currencyA : currencyB,
        currencyInputAmount: currencyAAmountQuotient || currencyBAmountQuotient,
        currencyOutputAmount: currencyAAmountQuotient ? currencyBAmountQuotient : currencyAAmountQuotient
    }), lpMinted = ref8.data;
    // liquidity minted
    var liquidityMinted = (0,react.useMemo)(function() {
        if ((pair === null || pair === void 0 ? void 0 : pair.liquidityToken) && totalSupply && lpMinted) {
            try {
                return swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(pair === null || pair === void 0 ? void 0 : pair.liquidityToken, lpMinted === null || lpMinted === void 0 ? void 0 : lpMinted.toString());
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        totalSupply,
        lpMinted
    ]);
    var poolTokenPercentage = (0,react.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new swap_sdk_src/* Percent */.gG(liquidityMinted.quotient, totalSupply.add(liquidityMinted).quotient);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var error;
    var addError;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (pairState === usePairs/* PairState.INVALID */._G.INVALID) {
        error = error !== null && error !== void 0 ? error : t("Choose a valid pair");
    }
    if (currencyAAmount && currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.equalTo(0)) && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.equalTo(0))) {
        error = error !== null && error !== void 0 ? error : t("No token balance");
    }
    if (!parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) {
        addError = t("Enter an amount");
    }
    if (currencyAAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(currencyAAmount))) {
        var ref9;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref9 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref9 === void 0 ? void 0 : ref9.symbol
        });
    }
    if (currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref3 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(currencyBAmount))) {
        var ref10;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref10 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref10 === void 0 ? void 0 : ref10.symbol
        });
    }
    return {
        dependentField: dependentField,
        currencies: currencies,
        pair: pair,
        pairState: pairState,
        currencyBalances: currencyBalances,
        parsedAmounts: parsedAmounts,
        price: price,
        noLiquidity: noLiquidity,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        error: error,
        addError: addError
    };
}


/***/ }),

/***/ 89216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useStableDerivedBurnInfo; },
/* harmony export */   "N": function() { return /* binding */ useGetRemovedTokenAmounts; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20414);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97477);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68486);
/* harmony import */ var state_burn_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54820);
/* harmony import */ var state_wallet_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5460);
/* harmony import */ var state_burn_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92015);
/* harmony import */ var views_AddLiquidity_AddStableLiquidity_hooks_useStableLPDerivedMintInfo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34934);
/* harmony import */ var views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12353);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8100);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);














function useGetRemovedTokenAmounts(param) {
    var lpAmount = param.lpAmount;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_7__/* .StableConfigContext */ .UA), stableSwapInfoContract = ref.stableSwapInfoContract, stableSwapConfig = ref.stableSwapConfig;
    var data = (0,swr__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(!lpAmount ? null : [
        "stableSwapInfoContract",
        "calc_coins_amount",
        stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress,
        lpAmount
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            return [
                2,
                stableSwapInfoContract.calc_coins_amount(stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress, lpAmount)
            ];
        });
    })).data;
    if (!Array.isArray(data)) return [];
    var tokenAAmount = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.token0, data[0].toString());
    var tokenBAmount = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.token1, data[1].toString());
    return [
        tokenAAmount,
        tokenBAmount
    ];
}
function useStableDerivedBurnInfo(currencyA, currencyB) {
    var ref, ref1;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().account;
    var ref2 = (0,state_burn_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useBurnState */ .Xi)(), independentField = ref2.independentField, typedValue = ref2.typedValue;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    // pair + totalsupply
    var pair = (0,views_AddLiquidity_AddStableLiquidity_hooks_useStableLPDerivedMintInfo__WEBPACK_IMPORTED_MODULE_6__/* .useStablePair */ .o)(currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped, currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped).pair;
    // balances
    var relevantTokenBalances = (0,state_wallet_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTokenBalances */ .Z)(account !== null && account !== void 0 ? account : undefined, [
        pair === null || pair === void 0 ? void 0 : pair.liquidityToken
    ]);
    var ref3;
    var userLiquidity = relevantTokenBalances === null || relevantTokenBalances === void 0 ? void 0 : relevantTokenBalances[(ref3 = pair === null || pair === void 0 ? void 0 : (ref = pair.liquidityToken) === null || ref === void 0 ? void 0 : ref.address) !== null && ref3 !== void 0 ? ref3 : ""];
    var percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG("0", "100");
    // user specified a %
    if (independentField === state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT) {
        percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(typedValue, "100");
    }
    var liquidityToRemove = userLiquidity && percentToRemove && percentToRemove.greaterThan("0") ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(userLiquidity.currency, percentToRemove.multiply(userLiquidity.quotient).quotient) : undefined;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(useGetRemovedTokenAmounts({
        lpAmount: liquidityToRemove === null || liquidityToRemove === void 0 ? void 0 : (ref1 = liquidityToRemove.quotient) === null || ref1 === void 0 ? void 0 : ref1.toString()
    }), 2), amountA = ref4[0], amountB = ref4[1];
    var _obj;
    var parsedAmounts = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, percentToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY */ .g.LIQUIDITY, liquidityToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.CURRENCY_A */ .g.CURRENCY_A, amountA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.CURRENCY_B */ .g.CURRENCY_B, amountB), _obj);
    var error;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (!parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY */ .g.LIQUIDITY]) {
        error = error !== null && error !== void 0 ? error : t("Enter an amount");
    }
    return {
        pair: pair,
        parsedAmounts: parsedAmounts,
        error: error
    };
}


/***/ })

}]);